import React, { Fragment } from "react";
import Button from "../../component/Button";
import YellowConfirm from "../../component/YellowConfirm";
import { connect } from "react-redux";
import { getAllAdminUsers, updateUser } from "../../reducers/account";

const formatAccount = (admin) => {
  return {
    tipoAccount:
      admin.role.type === "admingestionale"
        ? "Admin Gestionale"
        : admin.role.type === "supervisorgestionale"
        ? "Supervisore"
        : "Utente",
    text:
      admin.role.type === "admingestionale"
        ? "Ha accesso a tutte le parti del gesionale e può modificare Nomi, Account e Password degli altri account"
        : admin.role.type === "supervisorgestionale"
        ? "Ha accesso a tutte le parti del gesionale ma non può modificare gli Account"
        : "Ha accesso a tutte le parti del gesionale tranne Bilancio e Chat",
    username: admin.email,
    password: "*************",
    userId: Number(admin.id)
  };
};

const titleFontSize = 36;
const textFontSize = 18;

const styleInput = {
  borderStyle: "solid",
  borderWidth: "1.5px",
  marginTop: "1vh",
  marginBottom: "1vh",
  height: "2.6vh",
  width: "30vw",
  paddingLeft: 8,
  outline: 0,
  marginRight: "2vw",
};
const buttonStyle = {
  height: "2.6vh",
  marginBottom: "1vh",
  marginTop: "1vh",
};

class AccountManagement extends React.Component {
  state = {}

  componentDidMount() {
    this.props.getAllAdminUsers();
  }

  goBack = () => {
    this.props.history.push("/");
  };
  confirm = (userId) => {
    // update user
    const credentials = {
      email: this.state[`user_${userId}_email`],
      password: this.state[`user_${userId}_password`]
    }
    if (!!credentials.email && !!credentials.password) {
      // console.log(userId);
      // console.log(credentials);
      
      this.props.updateUser(userId, credentials)
    }
  };

  render() {
    // console.log(this.props);
    const accountList = this.props.admins.map(formatAccount);
    // console.log(accountList)
    return (
      <Fragment>
        <div
          style={{
            width: window.innerWidth,
            paddingTop: "6vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#FFE533",
              color: "#91855D",
              fontSize: 18,
              height: "6vh",
              marginTop: 4,
              width: "76vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Account Management
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {accountList.map((account) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "74vw",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    color: "#645B40",
                    fontSize: titleFontSize,
                    paddingTop: "3vh",
                  }}
                >
                  Account {account.tipoAccount}
                </div>
                <div style={{ fontSize: textFontSize, paddingTop: "1.6vh" }}>{account.text}</div>
                <div style={{ display: "flex", paddingTop: "2vh" }}>
                  <div style={{ width: "30vw", marginRight: 13 }}>Nome Account</div>
                  <div style={{ paddingLeft: "2vw" }}>Password</div>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    type="text"
                    style={styleInput}
                    placeholder={account.username}
                    onChange={(event) => this.setState({[`user_${account.userId}_email`]: event.target.value})}
                  />
                  <input
                    type="text"
                    style={styleInput}
                    placeholder={account.password}
                    onChange={(event) => this.setState({[`user_${account.userId}_password`]: event.target.value})}
                  />
                  <div style={buttonStyle}>
                    <YellowConfirm text={"Conferma"} action={() => this.confirm(account.userId)} padding={"0.6vh"} />
                  </div>
                </div>
                <hr style={{ width: "64vw", marginTop: "1.6vh", marginLeft: 0 }} />
              </div>
            ))}
          </div>
        </div>
        <div style={{ position: "absolute", top: "6vh", left: "3.2vh" }}>
          <Button {...this.props} scope={"back"} goTo={this.goBack} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  admins: state.account.admins,
});

export default connect(mapStateToProps, { getAllAdminUsers, updateUser })(AccountManagement);
